import { secureLocalStorage } from '~/utils/secureStorage'
import { jwtKeyStore, aesKeyStore, formDataStore, subDataStore } from '../../../../token-store'

export function setLocalData(formData: any, subData: any) {
  const updatedFormData = {
    fullName: formData.fullName,
    email: formData.email,
    phoneNumber: formData.phoneNumber,
    countryCode: formData.countryCode,
    organisationName: formData.organisationName,
    industryType: formData.industryType,
    subIndustryType: formData.subIndustryType,
    stripeCustomerId: formData.stripeCustomerId,
    stripePayementId: formData.stripePayementId,
    nextSubs: formData.nextSubs
  }

  const currentUTC = new Date().toISOString().split('T')[0] // Always UTC
  const tillDateUTC = new Date(subData.till).toISOString().split('T')[0]

  const currentDate = new Date(currentUTC)
  const tillDate = new Date(tillDateUTC)

  // Check the days remaining
  const timeDifference = tillDate.getTime() - currentDate.getTime()
  const daysRemaining = Math.ceil(timeDifference / (1000 * 60 * 60 * 24))

  let canCancel = true
  if (subData.isCancelled === true) {
    canCancel = false
  }

  const updatedSubData = {
    subscription: subData.subscription,
    createdAt: subData.createdAt,
    till: subData.till,
    expired: currentUTC > tillDateUTC,
    daysRemaining,
    promptRun: false,  // set the prompt run to false
    amount: subData.amount,
    duration: subData.duration,
    canCancel,
    subsChanged: false,
    isCancelled: subData.isCancelled || false,
    refunds: subData.refunds || []
  }


  formDataStore.set(updatedFormData)
  subDataStore.set(updatedSubData)
  jwtKeyStore.set(secureLocalStorage.getItem('jwt') || '')
  aesKeyStore.set(secureLocalStorage.getItem('aesKey') || '')
}
